import {RemoteGetAdherenceDigitalPayment} from 'data/usecases';
import {GetAdherenceDigitalPayment} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetAdherenceDigitalPayment = (): GetAdherenceDigitalPayment =>
	new RemoteGetAdherenceDigitalPayment(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.adherenceDigitalPayment),
		makeAuthorizeHttpClientDecorator(),
	);
